import { REACT_APP_HOST_URL } from 'envs';

const ABSOLUTE_URL_PREFIXES = ['http://', 'https://', '//', 'data:', 'blob:'] as const;

function isAbsoluteUrl(url: string): boolean {
	const trimmed = url.trim();
	return ABSOLUTE_URL_PREFIXES.some(prefix => trimmed.startsWith(prefix));
}

/**
 * Build a public asset URL based on HOST_URL.
 * - If `path` is already absolute (http(s), //, data:, blob:), it is returned unchanged.
 * - If HOST_URL is empty, returns the path as an app-relative URL (ensures leading "/").
 */
export function getHostAssetUrl(path: string, hostUrl: string = REACT_APP_HOST_URL || ''): string {
	if (!path) return path;
	if (isAbsoluteUrl(path)) return path;

	const normalisedPath = path.startsWith('/') ? path : `/${path}`;
	const normalisedHost = (hostUrl || '').trim().replace(/\/$/, '');

	return normalisedHost ? `${normalisedHost}${normalisedPath}` : normalisedPath;
}

